import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react'
import { Card, Col, Nav, Row, Tab } from 'react-bootstrap';
import AddFacilityStaff from '../add-facility-staff/AddFacilityStaff';
import ApprovedDevices from './DevicesList';
import DevicesList from './DevicesList';
import * as accessControlObj from '../../../authentication/accessControlMap'

const NavItem = ({ item, classNameCustom }) => {
  return (
    console.log(classNameCustom),
    <Nav.Item as="li" className={`${classNameCustom}`}>
      <Nav.Link
        className={`mb-0 py-3 px-1 cursor-pointer`}
        eventKey={item.toLowerCase().replaceAll(" ", "-")}>
        {item}
      </Nav.Link>
    </Nav.Item>
  );
};

const ViewFacilityStaffProfileBody = (props) => {
  const [navItems, setNavItems] = useState([]);
  const data = props.data;


  useEffect(() => {
    let localStorageAccessControl = localStorage.getItem("accessControl");
    let navtabs = ['Edit-Profile'];
    if (localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
      navtabs.push('Devices');
    }
    setNavItems(navtabs)
  },[])

  return (
    <Card className="mt-6">
      <Tab.Container id="audience-tab" defaultActiveKey="edit-profile">
        <Card.Header
          as={Flex}
          justifyContent="between"
          alignItems="center"
          className="p-0 border-bottom patientInfoTabs"
        >
          <Nav
            as="ul"
            className="nav-tabs border-0 d-flex w-100 flex-nowrap chart-tab tab-active-caret p-0"
          >
            {navItems.map(item => (
              <NavItem classNameCustom="col text-center" item={item} key={item} />
            ))}
          </Nav>
        </Card.Header>
        <Card.Body>
          <Row className="g-1">
            <Col xxl={12}>
              <Tab.Content>
                <Tab.Pane unmountOnExit eventKey="edit-profile">
                  <AddFacilityStaff dataObj={data} />
                </Tab.Pane>
                <Tab.Pane unmountOnExit eventKey="devices">
                  <DevicesList dataObj={data} />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Card.Body>
      </Tab.Container>
    </Card>
  )
}

export default ViewFacilityStaffProfileBody